import * as React from "react";
const SvgIcChevronDown = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m6.176 7.15 3.825 3.825 3.825-3.825 1.175 1.183-5 5-5-5L6.176 7.15Z" /></svg>;
export default SvgIcChevronDown;